<template>
  <div>
    <b-modal id="file-upload" hide-footer @hidden="onHidden">
      <form @submit.prevent="onSubmit" enctype="multipart/form-data">
        <div class="fields">
          <label>Upload File</label><br />
          <b-form-file
            ref="file"
            v-model="file"
            accept="image/jpeg, image/png, image/gif"
          ></b-form-file>
        </div>
        <div class="fields">
          <button>Submit</button>
        </div>
        <div class="message">
          <h5>{{ message }}</h5>
          <img v-if="this.headshot" class="mt-4" :src="this.headshot" />
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "FileUpload",
  data() {
    return {
      file: "",
      message: "",
      headshot: "",
    };
  },
  methods: {
    onSelect() {
      const file = this.$refs.file.files[0];
      this.file = file;
    },
    async onSubmit() {
      const formData = new FormData();
      if (this.file == "") {
        this.message = "No file, please try again";
      } else {
        formData.append("file", this.file);
        this.message = "uploading...";
        axios.post("https://vsgdrive.herokuapp.com/api/upload", formData).then(
          (response) => {
            //store the fileid in the customization object
            this.changeHeadshot(response.data);
          },
          (error) => {
            console.log(error);
            this.message = error;
          }
        );
      }
    },
    onHidden() {
      // fires when modal is closed
      // this.$store.commit("resetCustomization");
      // this.$bvModal.hide("confirm-delete");
    },
    changeHeadshot(fileid) {
      this.$store.commit("changeHeadshot", fileid);
      this.$bvModal.hide("file-upload");
    },
  },
};
</script>
